import { sanitizeRichHtml } from "@/shared/lib/html";
import { cn } from "@/shared/lib/utils";
import { useMemo } from "react";
import { RICH_TEXT_CLASS } from "./rich-text-styles";

interface RichTextContentProps {
  /** HTML z DB (popis produktu). Před vykreslením se sanitizuje. */
  html: string;
  className?: string;
  testId?: string;
}

/**
 * Vykreslí formátovaný text (HTML z editoru) na veřejném webu. HTML se VŽDY
 * sanitizuje přes DOMPurify (ochrana proti stored XSS) a styluje stejnými
 * třídami jako editor, takže výsledek odpovídá tomu, co admin viděl.
 */
export function RichTextContent({ html, className, testId }: RichTextContentProps) {
  const clean = useMemo(() => sanitizeRichHtml(html), [html]);
  return (
    <div
      className={cn(RICH_TEXT_CLASS, className)}
      data-testid={testId}
      // Sanitizováno výše přes DOMPurify (whitelist tagů/atributů/URL schémat).
      // biome-ignore lint/security/noDangerouslySetInnerHtml: obsah je sanitizovaný
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
